import React from "react"

export default function Blog026() {
  return (
    <section>
    <article>
    <h2>26. 11-25-2022</h2>
          <h3>TypeScript</h3>
          <p>
          <strong>Hey!</strong>
          <br /><br />
          My name is Eric Polley. I am a developer at ericpolley.com <br />
         I have built a few shopping carts using a few different methods in the last few days. <br />
         The first method I used to create a shopping cart was a Udemy course, Nextjs by Example. This course utilized 
         NextJS, Strapi, Tailwind, and Typescript. I found this tutorial very useful until we got to the utilization of 
         Strapi. The tutorial used an outdated version that no longer functions. In order to use the new Strapi, all of the code needs
         to be modified. This will not be a problem in the future, but not great for learning the first time around. 
         <br /> <br />
         This lead me to a course on EggHead.io. ECommerce Product Management & Storefront with GraphCMS, Snipcart, & Next.js. <br />
         This tutorial was full of usefull information. It game me the realization that SnipCart and Strapi were not that different. 
         <br /> I saw a lot of the same patterns. The core essentials of building a shopping cart, like grabbing static props 
         from json files and/or server provided readable's. I enjoyed creating this shop. I did run into trouble when it came time to 
         deploy the website. The heavy layers of languages, plug-in's, and add-ons make it very difficult to pin-point the source of 
         errors. 
         <br /> I build a shop from a tutorial by Web Dev Simplified. This tutorial used TypeScript and React. This gave me everything 
         I need to create a cosmetically pleasing shop website.  I understand now, from the previous tutorials, importing products from 
         a third party is a clients decision; Depending on the service, it may not be necessary at all. 
         <br />
         I would like to apply the shopping cart concept to add something to my website. I do not have anything to sell at the moment, 
         so I need a bit of time to figure that one out. Until then, I have used TypeScript and Nextjs with a few tutorials. 
         I would now like to take what I have learned and apply it to my own project, edit my resume, and add to my portfolio.  <br />
         <br />
         I added a link to the third shopping cart I have built. This shopping cart is not attached to a server, but the functionality is 
         all there. Check it out! <br />
         
         Thanks for reading <br />  ~Eric 


         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="https://jade-fenglisu-4cdf04.netlify.app"
              title="Shop!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Shopping Cart Website</p></strong></a
            >
          </li>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
